import SideDrawer from '../components/SideDrawer.js';
import Header from '../components/Header.js';
import AccountInfo from '../components/AccountInfo.js';
import '../styles/Dashboard.css';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import MainLayout from './MainLayout.js'

function Details() {
    const location = useLocation(); // Get the location object
    const [influencer, setInfluencer] = useState(null);
    const { isCollapsed } = useAuth();
    useEffect(() => {
        const influencerId = location.search.split('=')[1];
        const influencerData = localStorage.getItem(`selectedInfluencer${influencerId}`);
        if (influencerData) {
            setInfluencer(JSON.parse(influencerData));
        }
    }, []);
    if (!influencer) {
        return <div>No influencer data available.</div>; // Handle case where no data is passed
    }
  return (
    <MainLayout>
          <AccountInfo accountInfo={influencer}/>
    </MainLayout>
  );
}

export default Details;
